import api from '../lib/api';
export var GET_FORM_TEMPLATE = 'TEMPLATE_GET_FORM_SINGLE_TEMPLATE';
export var CLEAR_FORM_TEMPLATE = 'TEMPLATE_CLEAR_SINGLE_FORM_TEMPLATE';
export var GET_FORM_TEMPLATES_BY_TYPE = 'TEMPLATE_GET_FORM_TEMPLATES_BY_TYPE';
export var CREATE_FORM = 'TEMPLATE_ASSIGN_FORM_TEMPLATE';
export var SUBMIT_FORM = 'TEMPLATE_SUBMIT_FORM';
export var SUBMIT_FORM_SUCCESS = 'TEMPLATE_SUBMIT_FORM_SUCCESS';
export var SUBMIT_FORM_ERROR = 'TEMPLATE_SUBMIT_FORM_ERROR';
export var CLEAR_FORM_ERROR = 'TEMPLATE_CLEAR_FORM_ERROR';
export var UPDATE_FORM_INSTANCE = 'TEMPLATE_UPDATE_FORM_INSTANCE';
export var GET_FORM = 'TEMPLATE_GET_FORM';
export var CLEAR_FORM = 'TEMPLATE_CLEAR_FORM_DATA';
export var GET_FORMS = 'TEMPLATE_GET_FORMS';
export var GET_FORM_INSTANCE = 'TEMPLATE_GET_FORM_INSTANCE';
export var getFormTemplate = function getFormTemplate(id) {
  return {
    type: GET_FORM_TEMPLATE,
    payload: new Promise(function (resolve) {
      api.get("forms/template/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var clearFormTemplate = function clearFormTemplate() {
  return {
    type: CLEAR_FORM_TEMPLATE,
    payload: true
  };
};
export var getForm = function getForm(id) {
  return {
    type: GET_FORM,
    payload: new Promise(function (resolve) {
      api.get("forms/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var clearForm = function clearForm() {
  return {
    type: CLEAR_FORM,
    payload: true
  };
};
export var getForms = function getForms(type, startDate, endDate) {
  // Build query parameters only if arguments are provided
  var queryParams = [];
  if (type !== undefined && type !== null) queryParams.push("type=".concat(encodeURIComponent(type)));
  if (startDate !== undefined && startDate !== null) queryParams.push("startDate=".concat(encodeURIComponent(startDate)));
  if (endDate !== undefined && endDate !== null) queryParams.push("endDate=".concat(encodeURIComponent(endDate)));
  var queryString = queryParams.length > 0 ? "?".concat(queryParams.join('&')) : '';
  return {
    type: GET_FORMS,
    payload: new Promise(function (resolve) {
      api.get("forms".concat(queryString)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var updateFormInstance = function updateFormInstance(instance) {
  return {
    type: UPDATE_FORM_INSTANCE,
    payload: new Promise(function (resolve) {
      var values = JSON.stringify(instance);
      api.put("forms/instances", values).then(function (data) {
        resolve(data);
      });
    })
  };
};
export var getFormInstance = function getFormInstance(id) {
  return {
    type: GET_FORM_INSTANCE,
    payload: new Promise(function (resolve) {
      api.get("forms/instance/".concat(id)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getFormTemplatesByType = function getFormTemplatesByType(type) {
  return {
    type: GET_FORM_TEMPLATES_BY_TYPE,
    payload: new Promise(function (resolve) {
      api.get("FormTemplates?type=".concat(type)).then(function (response) {
        resolve({
          type: type,
          data: response.data
        });
      });
    })
  };
};
export var submitForm = function submitForm(formData, guardianId, studentId) {
  return {
    type: SUBMIT_FORM,
    payload: new Promise(function (resolve, reject) {
      // Construct the form object based on the API expectations
      var form = {
        Title: formData.title,
        Type: formData.type,
        Status: formData.status || 'SUBMITTED',
        FormTemplateID: formData.formTemplateId,
        FormInstances: [{
          FieldResults: formData.fieldResults.map(function (fr) {
            return {
              FieldName: fr.fieldName,
              Value: fr.value,
              FieldTemplateId: fr.FieldTemplateId
            };
          })
        }]
      };
      api.post("forms", form).then(function (response) {
        resolve(response.data);
      })["catch"](function (error) {
        reject(error);
      });
    })
  };
};
export var clearFormError = function clearFormError() {
  return {
    type: CLEAR_FORM_ERROR,
    payload: true
  };
};